let hrefAppDomain = ''; //预览c端的域名
let axiosApi='';//请求接口域名
let entryApi=''
/*测试*/



/****
 * 
 * 商家端只需要更改本页面
 * 
 */

hrefAppDomain = 'https://fx-wap.jiangxin-food.com/'; //移动端预览地址：测试装修c端页面预览入口
axiosApi= "https://fx-api.jiangxin-food.com/";//请求接口地址
entryApi = 'https://enter.beifamall.com';  //入驻端

export default {
    hrefAppDomain,//预览c端的域名
    entryApi,   //入驻地址
    axiosApi,//请求接口地址
    imgUrl: "https://pic.jiangxin-food.com/",//图片请求地址配置
    imgUpload: "https://fx-api.jiangxin-food.com/base/file/mgmt/addOneImage",
    name: "image",//图片上传时的字段名称
    loading: false,//请求时个加载页的开关
    userLoginId: sessionStorage.getItem("userLoginId"),//登录时返回的userLoginId
    global: sessionStorage.getItem("menu"),//登录账户的权限
    ownShop:sessionStorage.getItem("ownShop"),
    imgPreview: { //图片预览图
        flag: false,
        url: '',
    }, 
    hrefApp: hrefAppDomain+ "pages/goodsDetails/index?goodsId=",//跳转app的商品详情页
};



// WEBPACK FOOTER //
// ./src/config/api.js